import {
    BuildingLibraryIcon,
    ArrowUpIcon,
    CurrencyDollarIcon,
    ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';
import moment from 'moment';
import 'moment/locale/es';
import { NotificationsService } from '../../services/notifications/notifications.service';

moment.locale('es');

// Mapeo de tipos de notificaciones a íconos
const notificationIcons = {
    credit_payment: <CurrencyDollarIcon />,
    level_up: <ArrowUpIcon />,
    document_signed: <ClipboardDocumentCheckIcon />,
    novation: <BuildingLibraryIcon />,
    disbursement_made: <BuildingLibraryIcon />,
    updated_bank_account: <CurrencyDollarIcon />,
    confirm_bank_account: <CurrencyDollarIcon />,
};


// Función para obtener el ícono correspondiente a un tipo de notificación
export const getNotificationIcon = (type) => {
    return notificationIcons[type] || <BuildingLibraryIcon />; // ícono por defecto
};

export const renderNotification = (notification) => {
    const date = moment(notification?.createdAt).add(5, 'hours');
    const timeAgo = date.fromNow();

    return {
        id: notification?.notificationId,
        icon: getNotificationIcon(notification?.type), // Asignar el ícono basado en el tipo
        description: notification?.message,
        href: notification?.href,
        time: timeAgo,
        read: notification?.read,
        type: notification?.type
    };
};

// Función para guardar notificaciones en localStorage
export const saveNotificationsToLocalStorage = (notifications) => {
    localStorage.setItem('notifications', JSON.stringify(notifications));
};

// Función para agregar una notificación en localStorage
export const addNotificationToLocalStorage = (notification) => {
    let notifications = localStorage.getItem('notifications');
    let parsedNotifications = notifications ? JSON.parse(notifications) : [];
    if (!parsedNotifications.some(n => n.notificationId === notification?.notificationId)) {
        localStorage.setItem('notifications', JSON.stringify([notification, ...parsedNotifications]));
    }
};

// Función para agregar notificaciones obtenidas de paginación en localStorage
export const addNotificationsfromPaginateToLocalStorage = (moreNotifications) => {
    if (Array.isArray(moreNotifications) && moreNotifications.length > 0) {
        for (let index = 0; index < moreNotifications.length; index++) {
            const prevNotification = moreNotifications[index];
            let notifications = localStorage.getItem('notifications');
            let parsedNotifications = notifications ? JSON.parse(notifications) : [];

            if (!parsedNotifications.some(n => n.notificationId === prevNotification?.notificationId)) {
                localStorage.setItem('notifications', JSON.stringify([...parsedNotifications, prevNotification]));
            }
        }
    }
};


// Función markNotificationAsRead
export const markNotificationAsRead = (idNotification) => {
    let notifications = localStorage.getItem('notifications');
    let parsedNotifications = notifications ? JSON.parse(notifications) : [];

    const updatedNotifications = parsedNotifications.map(notification => {
        if (notification.notificationId === idNotification) {
            return { ...notification, read: true };
        }
        return notification;
    });
    localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
};


// Función para obtener notificaciones de localStorage
export const getNotificationsFromLocalStorage = () => {
    const notifications = localStorage.getItem('notifications');
    return notifications ? JSON.parse(notifications) : [];
};


export const loadNotificationsByUser = async (userId, page, limit) => {
    let lastNotifications = await NotificationsService.getNotifications(userId, page, limit);
    return lastNotifications;
};